<template>
  <div class="app">
    <NavBar></NavBar>
    <main class="app-content">
    <router-view></router-view>
    </main>
    <FooterBar></FooterBar>
    <a href="#" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
  </div>
</template>
<script>

import NavBar from '@/components/Common/NaviBar.vue'
import FooterBar from '@/components/Common/FooterBar.vue'

export default {
  name: 'App',
  components: { NavBar, FooterBar },
  data () {
    return {
      NavBar,
      FooterBar
    }
  },
  setup () {},
  created () {},
  mounted () {},
  unmounted () {},
  methods: {
  }
}
</script>
<style scoped>
#app {
  min-height: 100%;
  margin: 0;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.app-content > * {
  flex: 1;
}
</style>
